import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {getProductById, getProductRentalPriceByProductId} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import Config from "../../core/config";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import BackButton from "../common/BackButton";
import ConfirmButton from "../common/ConfirmButton";
import DecimalInput from "../common/DecimalInput";
import Cookies from "js-cookie";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import Loading from "../../core/Loading";
import {UserPermission} from "../../utils/utils";
import {usePermission} from "../../core/PermissionContext";

const apiUrl = Config.apiUrl;

const ProductManager = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const newEntity = {
        id: undefined,
        name: '',
        stock: 1,
        availableStock: 0,
        costValue: 0,
        supplier: '',
        brand: '',
        recommendedAge: '',
        details: '',
        customerOrientations: '',
        maxWeight: 0,
        pieces: []
    };
    
    const [formData, setFormData] = useState(newEntity);
    const newProductRentalPrice = {
        product: {id: 0, name: ''},
        days: 7,
        price: 0
    };

    const newProductPiece = {pieceName: '', quantity: 1};
    const [productRentalPrices, setProductRentalPrices] = useState([newProductRentalPrice]);
    const [productPieces, setProductPieces] = useState([newProductPiece]);

    const [productRentalPricesToRemove, setProductRentalPricesToRemove] = useState([]);
    const [productPiecesToRemove, setProductPiecesToRemove] = useState([]);
    const [isCopying, setIsCopying] = useState(false);

    /*
    const [selectedFile, setSelectedFile] = useState(null);    
    const [imageUrl, setImageUrl] = useState(null);


    const handleButtonClick = () => {
        document.getElementById('fileInput').click();
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
        setImageUrl(URL.createObjectURL(file));

        setFormData((prevData) => ({
            ...prevData,
            image: file,
        }));
    };


     */
    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : type === 'file' ? e.target.files[0] : value,
        }));
    };

    useEffect(() => {
        if (productRentalPrices[productRentalPrices.length - 1].days > 0 && productRentalPrices[productRentalPrices.length - 1].price > 0) {
            const productRentalPrice = newProductRentalPrice;
            productRentalPrice.days = productRentalPrices[productRentalPrices.length - 1].days + productRentalPrices[productRentalPrices.length - 1].days;
            setProductRentalPrices([...productRentalPrices, productRentalPrice]);
        }
    }, [productRentalPrices]);

    useEffect(() => {
        if (productPieces.length === 0 || productPieces[productPieces.length - 1].pieceName && productPieces[productPieces.length - 1].pieceName !== '') {
            setProductPieces([...productPieces, newProductPiece]);
        }
    }, [productPieces]);

    async function makeQuery() {
        if (id) {
            try {
                setLoading(true);
                const product = await getProductById(id);
                setFormData(product);
                setProductPieces(product.pieces)

                const productRentalPrices = await getProductRentalPriceByProductId(id);
                setProductRentalPrices([...productRentalPrices, newProductRentalPrice]);

            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        } else if (!isCopying) {
            // Só reseta se não estiver no modo cópia
            setFormData(newEntity);
            setProductRentalPrices([newProductRentalPrice]);
            setProductPieces([newProductPiece])
        }
    }

    useEffect(() => {
        if (!isCopying) {
            makeQuery();
        }
        setIsCopying(false);
    }, [id]);

    function validateInputs() {
        if (!formData.name || formData.name === '') {
            alert('Preencha o campo nome.');
            return false;
        }

        if(formData.costValue === undefined || formData.costValue === null || formData.costValue === '') {
            alert('Preencha o campo valor de compra.');
            return false;
        }

        if(formData.stock === undefined || formData.stock === null || formData.stock === '') {
            alert('Preencha o campo estoque.');
            return false;
        }

        return true;
    }

    async function saveEntity() {
        const userUUID = Cookies.get('userUUID');
        formData.pieces = productPieces.filter((p) => p.pieceName && p.pieceName !== '');
        const url = apiUrl + '/api/products';
        const productResponse = await makeRequest(url, formData.id ? 'PUT' : 'POST', {
            'Content-Type': 'application/json',
            'Useruuid': userUUID,
        }, JSON.stringify(formData));

        if (productResponse.id) {
            const currentProductRentalPrices = productRentalPrices.slice(0, -1);
            for (let i = 0; i < currentProductRentalPrices.length; i++) {
                const productRentalPrice = currentProductRentalPrices[i];
                productRentalPrice.product = productResponse;
                const url = apiUrl + '/api/product_rental_prices';
                await makeRequest(url, productRentalPrice.id ? 'PUT' : 'POST', {
                    'Content-Type': 'application/json',
                    'Useruuid': Cookies.get('userUUID')
                }, JSON.stringify(productRentalPrice));
            }
        }

        for (let i = 0; i < productRentalPricesToRemove.length; i++) {
            const productRentalPrice = productRentalPricesToRemove[i];
            if (productRentalPrice.id > 0) {
                const url = apiUrl + '/api/product_rental_prices/' + productRentalPrice.id;
                await makeRequest(url, 'DELETE', {
                    'Content-Type': 'application/json',
                     'Useruuid': Cookies.get('userUUID')
                }, JSON.stringify(productRentalPrice));
            }
        }
    }

    const onConfirm = async () => {
        try {
            if (validateInputs()) {
                setLoading(true);
                await new Promise(resolve => setTimeout(resolve, 300));
                await saveEntity();
                navigate('/app/productlist');
            }
        } catch (error) {
            console.error('Error saving:', error);
            alert('Error ao salvar.');
        } finally {
            setLoading(false);
        }
    };

    function clearEntity() {
        setFormData(newEntity);
        setProductRentalPrices([newProductRentalPrice]);
        setProductPieces([newProductPiece]);
    }

    function handleCopy() {
        // Ativar flag de cópia para evitar que o useEffect reset os dados
        setIsCopying(true);

        // Copiar dados do produto atual, excluindo id, code e availabilities
        // availabilities não devem ser copiadas pois são entidades managed pelo Hibernate
        // e causam erro "detached entity passed to persist" se incluídas
        const {id, code, availabilities, ...restFormData} = formData;
        const copiedFormData = {
            ...restFormData,
            name: formData.name ? `CÓPIA - ${formData.name}` : 'CÓPIA',
            availabilities: []  // Lista vazia para evitar erro de detached entity
        };
        setFormData(copiedFormData);

        // Copiar preços de locação, excluindo ids e filtrando apenas os válidos
        const copiedRentalPrices = productRentalPrices
            .filter((price) => price.days > 0 && price.price > 0)
            .map((price) => ({
                product: {id: 0, name: ''},
                days: price.days,
                price: price.price
            }));
        setProductRentalPrices([...copiedRentalPrices, newProductRentalPrice]);

        // Copiar peças, excluindo ids e filtrando apenas as válidas
        const copiedPieces = productPieces
            .filter((piece) => piece.pieceName && piece.pieceName !== '')
            .map((piece) => ({
                pieceName: piece.pieceName,
                quantity: piece.quantity
            }));
        setProductPieces([...copiedPieces, newProductPiece]);

        // Limpar listas de remoção
        setProductRentalPricesToRemove([]);
        setProductPiecesToRemove([]);

        // Remover id da URL para criar um novo produto
        const url = new URL(window.location.href);
        url.searchParams.delete('id');
        window.history.replaceState({}, '', url.toString());
        
        // Scroll para o topo
        window.scrollTo(0, 0);
    }

    function handleDaysChange(index, days) {
        setProductRentalPrices((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    days:
                    days
                } : item
            )
        );

    }

    function handlePieceNameChange(index, pieceName) {
        setProductPieces((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    pieceName:
                    pieceName
                } : item
            )
        );

    }

    function handlePieceQuantityChange(index, quantity) {
        setProductPieces((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    quantity:
                    quantity
                } : item
            )
        );

    }


    function handlePriceChange(index, price) {
        setProductRentalPrices((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? {
                    ...item,
                    price:
                    price,
                } : item
            )
        );

    }

    const removeItem = (index) => {
        setProductRentalPricesToRemove([...productRentalPricesToRemove, productRentalPrices[index]]);
        const novaLista = [...productRentalPrices];
        novaLista.splice(index, 1);
        setProductRentalPrices(novaLista);
    };
    const removePiece = (index) => {
        const novaLista = [...productPieces];
        novaLista.splice(index, 1);
        setProductPieces(novaLista);
    };

    if (loadingPermissions) {
        return <Loading></Loading>;
    }
    if (hasUserPermission(UserPermission.CREATE_PRODUCT) === false || (hasUserPermission(UserPermission.EDIT_PRODUCT) === false && id)) {
        navigate('/unauthorizedaccess');
        return null;
    }

    return (
        <div>

            <div style={{display: 'flex', alignItems: 'center'}}>
                <div className="header-label">{formData.id > 0 ? 'Editar' : 'Cadastrar'} Produto</div>
                {formData.id > 0 && (
                    <button onClick={handleCopy} style={{marginLeft: '10px', marginRight: '10px'}}>
                        Copiar
                    </button>
                )}
            </div>


            {/*{formData.id && (*/}
            {/*    <div style={{marginTop: '5px', alignItems: 'center'}}>*/}
            {/*        <div style={{width: '180px'}}>Código:</div>*/}
            {/*        <input type="text" style={{backgroundColor: '#CCCCCC'}} value={formData.id} disabled={true}/>*/}
            {/*    </div>)}*/}

            {/*<div style={{marginTop: '5px', alignItems: 'center'}}>*/}
            {/*    <div style={{width: '180px'}}>Foto:</div>*/}
            {/*    <input*/}
            {/*        type="file"*/}
            {/*        accept="image/*"*/}
            {/*        id="fileInput"*/}
            {/*        style={{display: 'none'}}*/}
            {/*        onChange={handleFileChange}*/}
            {/*    />*/}
            {/*    <button*/}
            {/*        onClick={handleButtonClick}*/}
            {/*    >*/}
            {/*        Escolher Foto*/}
            {/*    </button>*/}

            {/*    {imageUrl && <div><img src={imageUrl} style={{maxHeight: '100px'}} alt="Imagem selecionada"/></div>}*/}
            {/*</div>*/}

            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Nome:</div>
                    <input id="productName" type="text" style={{width: '300px'}} value={formData.name} name="name"
                           onChange={handleChange}/>
                </div>

                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div>Estoque:</div>
                    <input type="number" style={{width: '100px'}} step="1" placeholder="1" value={formData.stock}
                           name="stock"
                           onChange={handleChange}/>
                </div>

                {/*<div style={{marginTop: '5px', alignItems: 'center'}}>*/}
                {/*    <div style={{width: '180px'}}>Estoque disponível:</div>*/}
                {/*    <input type="number" style={{width: '100px'}} step="0.01" placeholder="0.00"*/}
                {/*           value={formData.availableStock}*/}
                {/*           name="availableStock"*/}
                {/*           onChange={handleChange}/>*/}
                {/*</div>*/}

                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Valor de Compra:</div>
                    <DecimalInput
                        style={{width: '100px'}}
                        placeholder="0,00"
                        value={formData.costValue}
                        name="costValue"
                        onChange={handleChange}/>
                </div>

            </div>
            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Fornecedor:</div>
                    <input type="text" style={{width: '200px'}} value={formData.supplier} name="supplier"
                           onChange={handleChange}/>
                </div>

                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div>Marca:</div>
                    <input type="text" style={{width: '200px'}} value={formData.brand} name="brand"
                           onChange={handleChange}/>
                </div>

                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div>Idade Recomendada:</div>
                    <input type="text" style={{width: '150px'}} value={formData.recommendedAge} name="recommendedAge"
                           onChange={handleChange}/>
                </div>

                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div>Peso Máximo em KG:</div>
                    <input type="number" style={{width: '150px'}} step="1" placeholder="0"
                           value={formData.maxWeight}
                           name="maxWeight"
                           onChange={handleChange}/>
                </div>
            </div>

            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Detalhes:</div>
                    <textarea style={{width: '300px', height: '50px'}} value={formData.details} name="details"
                              onChange={handleChange}/>
                </div>

                <div style={{marginTop: '5px', marginLeft: '5px', alignItems: 'center'}}>
                    <div style={{width: '180px'}}>Orientações ao Cliente:</div>
                    <textarea style={{width: '300px', height: '50px'}} value={formData.customerOrientations}
                              name="customerOrientations"
                              onChange={handleChange}/>
                </div>
            </div>


            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '250px'}}>Preços por período de Locação:</div>


                <table style={{height:'125px', border: '1px solid', borderColor: 'lightgray'}}>
                    <thead>
                    <tr>
                        <th>Dias Locação</th>
                        <th>Preço (R$)</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody style={{overflowY: 'auto'}}>
                    {productRentalPrices.map((item, index) => (
                        <tr key={item.id}>
                            <td>
                                <input key={item.id} type="number" step="1" placeholder="0"
                                       value={item.days}
                                       data-test={`rental-days-${index}`}
                                       onChange={(e) => handleDaysChange(index, parseFloat(e.target.value))}/>
                            </td>
                            <td>
                                <DecimalInput
                                    key={item.id}
                                    placeholder="0,00"
                                    value={item.price}
                                    data-test={`rental-price-${index}`}
                                    onChange={(e) => handlePriceChange(index, e.target.value)}/>
                            </td>
                            <td>
                                {index < productRentalPrices.length - 1 && (
                                    <button className="remove-button"
                                            onClick={() => removeItem(index)}>Excluir</button>)}
                            </td>
                        </tr>
                    ))}


                    </tbody>
                </table>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Peças:</div>

                <table style={{height: '125px', border: '1px solid', borderColor: 'lightgray'}}>
                    <thead>
                    <tr>
                        <th>Nome da Peça</th>
                        <th>Quantidade</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody style={{overflowY: 'auto'}}>
                    {productPieces.map((item, index) => (
                        <tr>
                            <td>
                                <input type="text"
                                       value={item.pieceName}
                                       data-test={`piece-name-${index}`}
                                       onChange={(e) => handlePieceNameChange(index, e.target.value)}/>
                            </td>
                            <td>
                                <input key={item.id} type="number" step="1" placeholder="1"
                                       value={item.quantity}
                                       data-test={`piece-quantity-${index}`}
                                       onChange={(e) => handlePieceQuantityChange(index, parseInt(e.target.value))}/>
                            </td>
                            <td>
                                {index < productPieces.length - 1 && (
                                    <button className="remove-button"
                                            onClick={() => removePiece(index)}>Excluir</button>)}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <ActionButtonsManagerView>
                <BackButton />
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>


        </div>
    );
};

export default ProductManager;
